import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface LeadRefetchResponse {
  lead: Lead;
}

const postLeadRefetch = async (
  authToken: string,
  leadId: string
): Promise<LeadRefetchResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${encodeURIComponent(leadId)}/refetch`,
    {},
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadRefetch;
